// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3361":"2a49ea46","5570":"30174c0f","6117":"62dbbc6e"}[chunkId] + ".chunk.css";
};